/**
 * @file 打开小程序页面
 * @author rongtan <rongtan@baidu.com>
 */

import register from '@baidu/xbox-vertical-na/register';
import getAppVersion from '@utils/get-app-version';
import inBox from '@utils/is-in-app';

/**
 * 打开小程序页面
 * @function openUlr
 * @param {Object} params 端能力参数
 * @return {Promise} 调用的返回
 */

export default (params = {}) => (
    register(
        {
            android: {
                versionRange: '0.1.0'
            },
            ios: {
                versionRange: '0.1.0'
            }
        },
        {
            module: 'swan',
            action: 'launchSwan',
            params
        },
        {
            appVersion: getAppVersion(),
            jsBridge: 'fcJsBridge',
            inBox: inBox()
        }
    )
);
